import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //presentLayerId:window.sessionStorage.getItem('currentLayerId')||'123',//token可以考虑这样写，但这里的presentLayerId应该保存到sessionStorage【js全局变量】里面去，而不应该放到vuex里，会导致问题。
    layersInfoList: [],
    terrainTransparency: 1,
    stageData: {
      arr: [],
      SimId: null,
    },
    simId: null,
    isPresentationMode: false, //是否是演示模式
  },
  getters: {},
  mutations: {
    // 修改演示模式
    changePresentationModeState(state, payload) {
      state.isPresentationMode = payload;
    },
    // setPresentLayerId(state,layerId){
    // 	state.presentLayerId=layerId;
    // },
    ADD_LAYER(state, layer) {
      state.layersInfoList.push(layer);
    },
    EDIT_LAYER(state, [layer, params]) {
      const i = state.layersInfoList.findIndex(
        (x) => x.layerId === layer.layerId
      );
      if (i !== -1) {
        if (params && params.length > 0) {
          params.map((v, j) => {
            state.layersInfoList[i].v = layer.v;
          });
        } else {
          state.layersInfoList[i] = layer;
        }
      } else {
        //没有匹配到就新增
        //layer值非空，params为空【params不为空更得考虑数据完整性问题】，就表明是一种有就修改，没有就新增的情况。
        if (layer && !params) {
          state.layersInfoList.push(layer);
        }
      }
    },
    // FIND_LAYER(state, layerId) {
    // 	const i = state.layersInfoList.findIndex(x => x.layerId === layerId);
    // 	if (i !== -1) {
    // 		return state.layersInfoList[i];
    // 	} else {
    // 		return {};
    // 	}
    // },
    DEL_LAYER(state, layerId) {
      state.layersInfoList.map((v, i) => {
        if (v.layerId === layerId) {
          state.layersInfoList.splice(i, 1);
        }
      });
    },
    sendStage(state, data) {
      state.stageData = data;
    },
    sendSimId(state, data) {
      state.simId = data;
    },
  },
  actions: {
    add_layer({ commit }, layer) {
      commit("ADD_LAYER", layer);
    },
    edit_layer({ commit }, [layer, params]) {
      commit("EDIT_LAYER", [layer, params]);
    },
    // find_layer({
    // 	commit
    // }, layerId) {
    // 	commit('FIND_LAYER', layerId);
    // },
    del_layer({ commit }, layerId) {
      commit("DEL_ITEM", layerId);
    },
  },
  getters: {
    // getPresentLayerId(state){
    // 	return state.presentLayerId;
    // }
    findLayerInfo: (state) => (layerId) => {
      let i = state.layersInfoList.findIndex(
        (todo) => todo.layerId === layerId
      );
      //alert(i);
      if (i !== -1) {
        return state.layersInfoList[i];
      } else {
        return {};
      }
    },
  },
  modules: {},
});
